import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaBox } from "react-icons/fa";
import api from "../../api";

const PackagesPage = () => {
  const [packages, setPackages] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  // Read query params example: ?type=Full%20Access
  const queryParams = new URLSearchParams(location.search);
  const typeFilter = decodeURIComponent(queryParams.get("type") || "");

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        let response;

        if (typeFilter.trim() !== "") {
          // Encode while sending to API
          const encodedType = encodeURIComponent(typeFilter);
          response = await api.get(`/customers/packagelist/type/${encodedType}`);
        } else {
          response = await api.get("/customers/packagelist/packages");
        }

        setPackages(response.data || []);
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };

    fetchPackages();
  }, [typeFilter]);

  const handlePay = (pkg) => {
    navigate("/customer/package-details", { state: { pkg } });
  };

  return (
    <div className="container mt-5 d-flex justify-content-center">
      <div style={{ maxWidth: "900px", width: "100%" }}>
        <h2 className="text-center mb-4">
          {typeFilter ? `Packages - ${typeFilter}` : "Available Packages"}
        </h2>

        <div className="row justify-content-center">
          {packages.length > 0 ? (
            packages.map((pkg, index) => (
              <div key={index} className="col-md-6 mb-4">
                <div className="card h-100 shadow-sm">
                  <div className="card-body d-flex align-items-center">
                    <div
                      className="me-3 text-primary"
                      style={{ fontSize: "2rem" }}
                    >
                      <FaBox />
                    </div>

                    <div className="flex-grow-1">
                      <h5 className="card-title">{pkg.packageName}</h5>
                      <p><strong>Type:</strong> {pkg.packageType}</p>
                      <p><strong>Price:</strong> ₹{pkg.amount}</p>
                      <p><strong>Transaction Fee:</strong> ₹{pkg.transactionFee}</p>
                      <p><strong>Validity:</strong> {pkg.validity} days</p>

                      <button
                        className="btn btn-success mt-2"
                        onClick={() => handlePay(pkg)}
                      >
                        Pay
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center">No packages found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PackagesPage;
